import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";

import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";

import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";

@Component({
	selector: "modal-address",
	templateUrl: "./modal-address.html"
})
export class AddressModalPage {
	public type_address: any = "state";
	address_type_list: any = [];

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public addOrderService: AddOrderServiceProvider,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
	) {
		this.type_address = navParams.get("type");
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	ionViewDidLoad() {}

	selectAddressTypeValue(value) {
		this.addOrderService.masterAddressId = null;
		this.addOrderService.is_multiple_address = false;
		this.addOrderService.is_multiple_pincode = false;
		this.addOrderService.newmissingAddress = false;

		this.addOrderService.postData[this.type_address] = value;

		if (this.type_address === "pincode") {
			this.dismiss();
			return false;
		}

		let addressInfo: any = {};

		addressInfo.state_name = value;

		if (this.type_address === "state") {
			addressInfo.state_name = value;
			addressInfo.searchon = "district_name";

			this.addOrderService.postData.district = null;
			this.addOrderService.postData.tehsil = null;
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;
		}

		if (this.type_address === "district") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;

			this.addOrderService.postData.tehsil = null;
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;

			addressInfo.searchon = "tehsil_name";
		}

		if (this.type_address === "tehsil") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;
			addressInfo.tehsil_name = this.addOrderService.postData.tehsil;

			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;

			addressInfo.searchon = "village_name";
		}

		if (this.type_address === "village") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;
			addressInfo.tehsil_name = this.addOrderService.postData.tehsil;
			addressInfo.village_name = this.addOrderService.postData.village;

			this.addOrderService.postData.pincode = null;

			addressInfo.searchon = "pincode";
		}

		this.apiService
			.post("customer/address/info", addressInfo)
			.subscribe(response => {
				var result = response["data"];

				var dataLength = result.length;

				this.addOrderService.is_multiple_pincode = false;
				this.addOrderService.is_multiple_address = false;

				if (this.type_address === "state") {
					this.addOrderService.all_district = [];
					this.addOrderService.all_district = result;
				}

				if (this.type_address === "district") {
					this.addOrderService.all_tehsil = [];
					this.addOrderService.all_tehsil = result;
				}

				if (this.type_address === "tehsil") {
					this.addOrderService.all_village = [];
					this.addOrderService.all_village = result;
				}

				if (this.type_address === "village") {
					if (dataLength === 1) {
						this.addOrderService.postData.pincode = result[0];
					}

					if (dataLength > 1) {
						this.addOrderService.is_multiple_pincode = true;
						this.addOrderService.all_pincode = [];
						this.addOrderService.all_pincode = result;
					} else {
						this.addOrderService.is_multiple_pincode = false;
						this.addOrderService.all_pincode = [];
					}
				}
			});

		this.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/modals/address/address.modal.ts